"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.createAccountFromDevice = exports.DerivationsCache = void 0;
var logs_1 = require("@ledgerhq/logs");
// In order to not re-query the same path, we use a temporary cache
var DerivationsCache = /** @class */ (function () {
    function DerivationsCache() {
        this.store = {};
    }
    return DerivationsCache;
}());
exports.DerivationsCache = DerivationsCache;
var createAccountFromDevice = function (_a) {
    var core = _a.core, wallet = _a.wallet, currency = _a.currency, derivationMode = _a.derivationMode, isUnsubscribed = _a.isUnsubscribed, derivationsCache = _a.derivationsCache, getAddress = _a.getAddress;
    return __awaiter(void 0, void 0, void 0, function () {
        var accountCreationInfos, chainCodes, publicKeys, index, derivations, owners, newAccountCreationInfos, account;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    (0, logs_1.log)("libcore", "createAccountFromDevice " + currency.id + " " + derivationMode);
                    return [4 /*yield*/, wallet.getNextAccountCreationInfo()];
                case 1:
                    accountCreationInfos = _b.sent();
                    if (isUnsubscribed())
                        return [2 /*return*/];
                    return [4 /*yield*/, accountCreationInfos.getChainCodes()];
                case 2:
                    chainCodes = _b.sent();
                    if (isUnsubscribed())
                        return [2 /*return*/];
                    return [4 /*yield*/, accountCreationInfos.getPublicKeys()];
                case 3:
                    publicKeys = _b.sent();
                    if (isUnsubscribed())
                        return [2 /*return*/];
                    return [4 /*yield*/, accountCreationInfos.getIndex()];
                case 4:
                    index = _b.sent();
                    if (isUnsubscribed())
                        return [2 /*return*/];
                    return [4 /*yield*/, accountCreationInfos.getDerivations()];
                case 5:
                    derivations = _b.sent();
                    if (isUnsubscribed())
                        return [2 /*return*/];
                    return [4 /*yield*/, accountCreationInfos.getOwners()];
                case 6:
                    owners = _b.sent();
                    if (isUnsubscribed())
                        return [2 /*return*/];
                    return [4 /*yield*/, derivations.reduce(function (promise, derivation) {
                            return promise.then(function () { return __awaiter(void 0, void 0, void 0, function () {
                                var cache, publicKey, chainCode;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (isUnsubscribed())
                                                return [2 /*return*/];
                                            cache = derivationsCache.store[derivation];
                                            if (!!cache) return [3 /*break*/, 2];
                                            return [4 /*yield*/, getAddress({
                                                    currency: currency,
                                                    path: derivation,
                                                    derivationMode: derivationMode,
                                                    askChainCode: true,
                                                    skipAppFailSafeCheck: true
                                                })];
                                        case 1:
                                            cache = _a.sent();
                                            derivationsCache.store[derivation] = cache;
                                            _a.label = 2;
                                        case 2:
                                            publicKey = cache.publicKey, chainCode = cache.chainCode;
                                            publicKeys.push(publicKey);
                                            if (chainCode)
                                                chainCodes.push(chainCode);
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                        }, Promise.resolve())];
                case 7:
                    _b.sent();
                    if (isUnsubscribed())
                        return [2 /*return*/];
                    (0, logs_1.log)("libcore", "AccountCreationInfo.init", {
                        index: index,
                        owners: owners,
                        derivations: derivations,
                        publicKeys: publicKeys,
                        chainCodes: chainCodes
                    });
                    return [4 /*yield*/, core.AccountCreationInfo.init(index, owners, derivations, publicKeys, chainCodes)];
                case 8:
                    newAccountCreationInfos = _b.sent();
                    if (isUnsubscribed())
                        return [2 /*return*/];
                    return [4 /*yield*/, wallet.newAccountWithInfo(newAccountCreationInfos)];
                case 9:
                    account = _b.sent();
                    return [2 /*return*/, account];
            }
        });
    });
};
exports.createAccountFromDevice = createAccountFromDevice;
//# sourceMappingURL=createAccountFromDevice.js.map